import React, { Component } from "react";
import { Container, List } from "semantic-ui-react";

class About extends Component {

	render () {

		return (

			<Container>
				<h2>Links and Examples</h2>
				<p>Most of my important code has been written for employers whose codebases are not public, but here are a few links to examples of my work, and various public profiles.</p>
				<List>
					<List.Item icon="twitter" content={<a target="_blank" href="https://twitter.com/captndestructo">Twitter</a>} />
					<List.Item icon="github" content={<a target="_blank" href="https://github.com/AlanBreck">GitHub</a>} />
					<List.Item icon="codepen" content={<a target="_blank" href="http://codepen.io/AlanBreck/">CodePen</a>} />
					{/*<List.Item icon="file pdf outline icon" content={<a target="_blank" href="http://jacoblamont.com/jacob-lamont-resume.pdf">Resume</a>} />*/}
					<List.Item icon="video play" content={<a target="_blank" href="https://scrimba.com/@AlanBreck">Scrimba</a>} />
				</List>
			</Container>

		);

	}

}

export default About;



/** WEBPACK FOOTER **
 ** ./src/modules/Examples.js
 **/